import React from "react";
interface Props {
  className?: string;
}

function HandshakeIcon({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
    >
      <rect
        width="23.5"
        height="23.5"
        x="0.25"
        y="0.25"
        stroke="#666"
        strokeWidth="0.5"
        rx="11.75"
      ></rect>
      <path
        fill="#666"
        d="M17.753 11.142L16.556 8.75a.562.562 0 00-.755-.252l-1.229.612-2.525-.667a.183.183 0 00-.094 0l-2.526.667-1.229-.614a.563.563 0 00-.754.252l-1.197 2.393a.563.563 0 00.252.754l1.279.64 2.613 1.867a.18.18 0 00.063.029l3 .75a.186.186 0 00.178-.047l2.604-2.604L17.5 11.9a.562.562 0 00.252-.755v-.002zm-2.39 1.732l-1.745-1.397a.188.188 0 00-.25.014c-.914.92-1.938.802-2.592.384a.19.19 0 01-.034-.291l2.084-2.022h1.683l1.387 2.776-.534.536zm-8.79-1.422a.187.187 0 01.01-.14L7.78 8.916a.187.187 0 01.166-.104c.029 0 .058.007.083.02l1.125.563-1.364 2.729-1.125-.563a.188.188 0 01-.094-.109zm6.87 3.34l-2.863-.716-2.466-1.76 1.423-2.847L12 8.819l1.393.368h-.643a.188.188 0 00-.131.053l-2.142 2.078a.56.56 0 00.096.873c.932.596 2.069.469 2.938-.32l1.583 1.27-1.652 1.651zm3.984-3.34a.186.186 0 01-.094.11l-1.125.562-1.364-2.729 1.125-.563a.188.188 0 01.25.084l1.196 2.393a.187.187 0 01.012.143zm-5.43 4.72a.188.188 0 01-.229.135l-1.953-.49a.188.188 0 01-.064-.028l-1.235-.883a.187.187 0 01.218-.305l1.206.861 1.921.48a.187.187 0 01.136.23z"
      ></path>
    </svg>
  );
}

export default HandshakeIcon;
